export default __webpack_public_path__ + "static/media/calendarIcon.9c192162.svg";